window.Products.WallArt.WoodPrint = function() {
	this.texture = new Image(1024, 1024);
	this.bufferCanvas = document.createElement('canvas');
	this.bufferCanvas.width = 1024;
	this.bufferCanvas.height = 1024;
};
window.Products.WallArt.WoodPrint.inherits(window.Products.WallArt.ArtProduct);
window.Products.WallArt.WoodPrint.id = 40;
window.Products.WallArt.WoodPrint.saveId = 37;
window.Products.WallArt.WoodPrint.slug = 'wood-print';
window.Products.WallArt.WoodPrint.has_3d = true;
window.Products.WallArt.WoodPrint.use_variants = true;
window.Products.WallArt.WoodPrint.dpi = 300;

window.Products.WallArt.WoodPrint.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);

	modelViewer.object.children[1].material.side = THREE.DoubleSide;
	modelViewer.object.children[1].material.bumpScale = 0.01;

	modelViewer.camera_light.intensity = 0.4;
	modelViewer.camera_light.color = {r: 0.8, g: 0.8, b: 0.8};
	modelViewer.camera.position.z = 1.78;
	modelViewer.initalCameraPosition.z = 1.78;
};

window.Products.WallArt.WoodPrint.prototype.updateThreeTexture = function(modelViewer) {
	if(!modelViewer.inlab){
		var me = this;
		this.loadPrepassTexture(function(){
			ctx = modelViewer.texture.image.getContext("2d");
			me.textureCanvasPrepass(ctx);
			ctx.globalCompositeOperation = "multiply";
			if(typeof modelViewer.textureImage !== 'undefined'){
				ctx.drawImage(modelViewer.textureImage, 0, 0, modelViewer.texture.image.width, modelViewer.texture.image.height);
				modelViewer.texture.needsUpdate = true;
			}
			ctx.globalCompositeOperation = "source-over";
		});
	}
	modelViewer.object.children[1].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.bumpMap = modelViewer.texture;
};

window.Products.WallArt.WoodPrint.prototype.loadPrepassTexture = function(callback){
	this.texture.crossOrigin = 'Anonymous';
	this.texture.src = THREE_JSON_URL + 'textures/wood_top.jpg';
	this.texture.onload = callback;
};

window.Products.WallArt.WoodPrint.prototype.textureCanvasPrepass = function(ctx){
	var me = this;

	//Make sure it's loaded first
	if(isImgLoaded(this.texture)) {
		ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		ctx.drawImage(this.texture, 0, 0, this.parent.static.magic_size, this.parent.static.magic_size);
		switch(this.white) {
			case 'bright-white':
				ctx.globalAlpha = 0.75;
				ctx.fillStyle = "#ffffff";
				ctx.fillRect(0, 0, this.parent.static.magic_size, this.parent.static.magic_size);
				ctx.globalAlpha = 1;
				break;
		}
	} else {
		//Load image
		this.loadPrepassTexture(function() {
			me.textureCanvasPrepass(ctx);
		});
	}

	ctx.globalCompositeOperation = "multiply";
};

window.Products.WallArt.WoodPrint.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.4;
	controls.maxDistance = 2.4;
	controls.minPolarAngle = Math.PI/2;
	controls.maxPolarAngle = Math.PI/2;
};